import { gql } from '@apollo/client'
import { client } from '../client';


const SEND_AUTH_NOTIFICATION_MUTATION = gql`
  mutation SendAuthNotification($qtirLanguageId: Int!, $phoneNumber: String!, $transportationId: Int, $email: String, $newPin: Boolean!) {
    sendAuthNotification(qtirLanguageId: $qtirLanguageId, phoneNumber: $phoneNumber, transportationId: $transportationId, email: $email, newPin: $newPin)
  }
`

interface SendAuthNotificationData {
  sendAuthNotification: boolean
}

interface SendAuthNotificationVars {
  phoneNumber: string,
  qtirLanguageId: number,
  newPin: boolean,
  transportationId?: number,
  email?: string,
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const sendAuthNotification = (args: SendAuthNotificationVars) => {
  return client.mutate<SendAuthNotificationData, SendAuthNotificationVars>({
    mutation: SEND_AUTH_NOTIFICATION_MUTATION,
    variables: args,
  })
}
